import { FooterProps } from './Footer.type';

const Footer = ({
  footerIcon,
  social,
  download,
  copyright,
  service,
  explore,
  topUp,
  officeInfo,
  qrCode,
}: FooterProps) => (
  <div className="footer-wrapper">
    <div className="footer-main-container">
      <div className="footer-container">
        <div className="footer-left">
          <div id="footer-icon--left">{footerIcon}</div>
          <div className="footer-section-container">
            {officeInfo ? (
              <div className="footer-info">
                {officeInfo.map((line) => (
                  <div key={line} className="footer-section-label">
                    {line}
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}
            <div className="footer-section-label">{social.label}</div>
            <div className="footer-icon-container">
              {social.content.map((data) => (
                <a key={data.url} href={data.url}>
                  {data.icon}
                </a>
              ))}
            </div>
            <div className="footer-section-label">{download.label}</div>
            <div
              className="footer-icon-container"
              id="footer-download-container"
            >
              {download.content.map((data) => (
                <a key={data.url} href={data.url}>
                  {data.icon}
                </a>
              ))}
            </div>
            {qrCode ?? ''}
          </div>
        </div>
        <div className="footer-right">
          <div id="footer-icon--right">{footerIcon}</div>
          <div className="footer-top-right">
            <div className="footer-section-container">
              <div className="footer-section-label">{service.label}</div>
              {service.content.map((link) => (
                <a
                  key={link.url}
                  href={link.url}
                  className="footer-link"
                  {...link.props}
                >
                  {link.label}
                </a>
              ))}
            </div>
            <div className="footer-section-container">
              <div className="footer-section-label">{explore.label}</div>
              {explore.content.map((link) => (
                <a
                  key={link.url}
                  href={link.url}
                  className="footer-link"
                  {...link.props}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
          {topUp && (
            <>
              <div className="footer-section-label">{topUp.label}</div>
              <div className="footer-topup-icon-container">
                {topUp.content?.map((icon) => icon)}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="footer-copyright">
        <p>{copyright.label}</p>
        {copyright.content ? (
          <div className="footer-copyright-links">
            {copyright.content.map((link, index) => (
              <div key={link.url}>
                <a href={link.url} className="footer-link" {...link.props}>
                  {link.label}
                </a>
                {index + 1 !== copyright.content.length && ' | '}
              </div>
            ))}
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  </div>
);

export default Footer;
